<div class="bb-position">
	<div class="position-row" *ngFor="let ypos of positions">
		<bb-radio [shape]="'square'" *ngFor="let xpos of ypos" name="position-{{xpos}}" (onChanged)="valueChanged($event)" [(ngModel)]="positionModel.value" [val]="xpos"></bb-radio>
	</div>
</div>